module.exports = __webpack_public_path__ + "static/media/paypal.09dad0cd.svg";